import React, { useContext, useEffect } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import MenuTop from "../../components/MenuTop/MenuTop";
import PdfEditor from "../../components/PdfEditor/PdfEditor";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { useLocation, useNavigate } from "react-router-dom";

const CreateDocument: React.FC = () => {
  const { setIdEditDocument, getDocumentSign, getSignersEdit, setCollaborators, collaborators } =
    useContext(DocumentTypeContext);

  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {

    const storedState = localStorage.getItem("collaborator-storage");
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      if (parsedState?.state?.collaborators?.length > 0) {
        setCollaborators(parsedState.state.collaborators);
      }
    }

    const url = window.location.href;
    const urlObj = new URL(url);
    const documentId = urlObj.searchParams.get("documentId");

    const getDocument = async () => {
      if (documentId) {
        setIdEditDocument(documentId);
        await getDocumentSign(documentId);
        await getSignersEdit(documentId);
      }
    };

    getDocument();
  }, [setCollaborators, setIdEditDocument, getDocumentSign, getSignersEdit]);

  return (
    <>
      <LoadingSpinner />
      <MenuTop />
      <div className="create-document-container">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="create-document-header">
            <span className="create-document-title">ASSINAR DOCUMENTO</span>
            <span className="create-document-subtitle">
              ESCOLHA ONDE DESEJA ASSINAR E RUBRICAR
            </span>
            <span className="create-document-hint create-document-hint-desktop">
              O posicionamento é opcional. Caso não deseje posicionar, clique diretamente em "Enviar para Assinatura".
            </span>
            <span className="create-document-hint create-document-hint-mobile">
              Para posicionar assinaturas no documento, utilize o desktop. No celular, clique em "Enviar para Assinatura" para enviar sem posicionamento.
            </span>
          </div>
          <PdfEditor />
        </div>
      </div>

      <style>{`
        .create-document-container {
          margin: 8px;
          padding: 16px;
          background-color: #fff;
          border-radius: 8px;
          display: flex;
          flex-direction: row;
          gap: 20px;
        }
        .create-document-header {
          display: flex;
          flex-direction: column;
          margin-bottom: 16px;
        }
        .create-document-title {
          text-align: left;
          letter-spacing: 2px;
          color: #222;
          font-weight: 600;
          font-size: 20px;
        }
        .create-document-subtitle {
          text-align: left;
          letter-spacing: 0.5px;
          color: #757575;
          font-size: 14px;
        }
        .create-document-hint {
          font-size: 13px;
          color: #888;
          margin-top: 4px;
        }
        .create-document-hint-mobile {
          display: none;
        }
        @media (max-width: 768px) {
          .create-document-hint-desktop {
            display: none;
          }
          .create-document-hint-mobile {
            display: block;
            background-color: #fff3e0;
            border: 1px solid #ffe0b2;
            border-radius: 6px;
            padding: 8px 12px;
            color: #e65100;
            font-size: 12px;
            margin-top: 8px;
          }
          .create-document-container {
            margin: 0;
            padding: 10px 8px;
            flex-direction: column;
            overflow-x: hidden;
          }
          .create-document-title {
            font-size: 16px;
            letter-spacing: 1px;
          }
          .create-document-subtitle {
            font-size: 12px;
          }
          .create-document-hint {
            font-size: 11px;
          }
        }
      `}</style>
    </>
  );
};

export default CreateDocument;
